<router-outlet />

<!-- Contenedor global de notificaciones. Va en el shell y no en cada módulo:
     es uno solo para toda la aplicación y tiene que quedar por encima de
     drawers y modales. -->
<app-notify-host />
